import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useMutation, useUser } from "hooks";
import { mutationActivateLicenseCode } from "graph";
import { getEntityUrl } from "common/Links";
import Keyvisual from "common/Keyvisual";
import Loading from "common/Loading";
import RequestLoginModal from "common/RequestLoginModal";
import { useTranslation } from "react-i18next";
import { Alert, Button, Container, Row, Col } from "react-bootstrap";

export default function ActivateLicenseCode() {
	const { t } = useTranslation("account");
	const { code } = useParams();
	const history = useHistory();
	const user = useUser();
	const [result, setResult] = useState(null);
	const [error, setError] = useState(null);
	const [showLogin, setShowLogin] = useState(false);

	const [doActivateCode, { loading }] = useMutation(
		mutationActivateLicenseCode,
		{
			onError: (err) => {
				setError(err.message || t("license_manager.deeplink.error_generic"));
			},
			onCompleted: (data) => {
				setResult(data.activateLicenseCode);
			},
		}
	);

	useEffect(() => {
		if (!user) {
			setShowLogin(true);
			return;
		}
		if (code) {
			doActivateCode({
				variables: {
					input: { code },
				},
			});
		}
	}, [code, user, doActivateCode]);

	return (
		<>
			<Keyvisual title={t("license_manager.deeplink.title")} />
			<Container className="my-5">
				<Row className="justify-content-center">
					<Col md={8} lg={6}>
						{!user && (
							<RequestLoginModal
								show={showLogin}
								handleClose={() => {
									setShowLogin(false);
									history.push("/");
								}}
							/>
						)}

						{loading && (
							<Loading text={t("license_manager.deeplink.activating")} />
						)}

						{result && (
							<Alert variant="success">
								<Alert.Heading>
									{t("license_manager.deeplink.success_title")}
								</Alert.Heading>
								<p>
									{t("license_manager.deeplink.success_message", {
										name: result.product?.name || "",
									})}
								</p>
								<hr />
								<div className="d-flex justify-content-end">
									<Button
										variant="outline-success"
										onClick={() =>
											history.push(
												result.product
													? getEntityUrl(result.product)
													: "/benutzerkonto"
											)
										}
									>
										{t("license_manager.deeplink.to_product")}
									</Button>
								</div>
							</Alert>
						)}

						{error && (
							<Alert variant="danger">
								<Alert.Heading>
									{t("license_manager.deeplink.error_title")}
								</Alert.Heading>
								<p>{error}</p>
								<hr />
								<div className="d-flex justify-content-end">
									<Button
										variant="outline-danger"
										onClick={() => history.push("/")}
									>
										{t("license_manager.deeplink.to_shop")}
									</Button>
								</div>
							</Alert>
						)}
					</Col>
				</Row>
			</Container>
		</>
	);
}
